import {create} from 'zustand';
import {persist, createJSONStorage, devtools} from 'zustand/middleware';
import {getPageContent} from '../firebase/services/pageService';

const PAGE_IDS = [
  'macarons',
  'cookies',
  'tortas',
  'tartas-clasicas',
  'travel-cakes',
  'tortas-modernas',
];

export const useContentStore = create(
    devtools(
        persist(
            (set, get) => ({
              pages: {},
              loading: false,
              error: null,

              fetchAllPages: async () => {
                if (Object.keys(get().pages).length > 0) return;
                set(
                    {loading: true, error: null},
                    false,
                    'fetchAllPages/pending',
                );
                try {
                  const results = await Promise.all(
                      PAGE_IDS.map((id) => getPageContent(id)),
                  );
                  const pages = Object.fromEntries(
                      PAGE_IDS.map((id, i) => [id, results[i]]),
                  );
                  set(
                      {pages, loading: false},
                      false,
                      'fetchAllPages/fulfilled',
                  );
                } catch (err) {
                  set(
                      {error: err.message, loading: false},
                      false,
                      'fetchAllPages/rejected',
                  );
                }
              },
            }),
            {
              name: 'content-storage',
              storage: createJSONStorage(() => sessionStorage),
            },
        ),
        {name: 'ContentStore'},
    ),
);
